import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import { mask } from "vue-the-mask";
import "font-awesome/css/font-awesome.min.css";
import VueTheMask from "vue-the-mask";

Vue.use(VueTheMask);
import axios from "axios";
import VueResource from 'vue-resource'

import Chartkick from 'vue-chartkick'
import Chart from 'chart.js'

Vue.use(Chartkick.use(Chart))
Vue.use(VueResource)
//defined as global component
Vue.component(
    "VueFontawesome",
    require("vue-fontawesome-icon/src/components/VueFontawesome.vue").default
);
Vue.config.productionTip = false;
Vue.prototype.$bbtnNuevo;

Vue.prototype.$nombreEmpresa = "DecaSystems";
Vue.prototype.$imagen = "../src/assets/log.png";
Vue.prototype.$user = {
    userid: "bibbia", passwd: "", jdbcJDNI: "", sudo: true,
    dashboard: true, micromarket: false, transportnet: false, gubernamental: false, verVentasCaja: false
};

Vue.prototype.$ImgName = "./assets/log.png";
Vue.prototype.$IdUser = "1";
Vue.prototype.$UseName = "Admin";
Vue.prototype.$Version = "Decasystems 1.25";
const appConfig = window.APP_CONFIG || {};
const apiUrl = appConfig.HOSTNAME || process.env.VUE_APP_API_URL || "";
const apiContext = appConfig.API || process.env.VUE_APP_API_CONTEXT || "";
Vue.prototype.$hostname = apiUrl ? `${apiUrl.replace(/\/+$/, "")}/` : "";
Vue.prototype.$hName = apiContext ? apiContext.replace(/^\/+|\/+$/g, "") : "";

//Vue.prototype.$hostname = 'https://localhost:8081/';
//Vue.prototype.$hostname = 'https://api.farmacoms2.net/';
//Vue.prototype.$hostname = 'https://apiyna.farmacom.net/';
//Vue.prototype.$hostname = 'https://api.micromarkets1.net/';
//Vue.prototype.$hostname = 'https://apys2.micromarket.cloud/';
//Vue.prototype.$hostname = 'https://apytest.farmacom.net/';
//Vue.prototype.$hName = 'api';

//Vue.prototype.$hostname = window.APP_CONFIG.HOSTNAME
//Vue.prototype.$hName = window.APP_CONFIG.API/**/

Vue.prototype.$axios = axios;
Vue.prototype.$Bearer = "Bearer ";

Vue.prototype.$User = "administrador";
Vue.prototype.$CodeUser = "bibbia"; 

Vue.prototype.$rules = {
    required: value => !!value || "Requerido.",
    edad: [
        val => val > 10 || `Edad debe ser mayor a 10`,
        val => val < 70 || `Edad debe ser menor a 120`
    ],
    counter: value => (value && value.length <= 50) || "Max 50 characters",
    RulesTel: value => (value.length == 0 || value.length == 13) || `telefono debe tener 10 digitos`,
    //RulesTel: value => (value && value.length == 13) || `telefono debe tener 10 digitos`,
    //RulesCel: value => (value && value.length  ==13) || `Cedula debe tener 11 digitos`,
    RulesCel: value => (value.length == 0 || value.length == 13) || `Cedula debe tener 11 digitos`,
    RulesRnc: value => (value && value.length == 11) || `RNC debe tener 9 digitos`,
    RulesCelRnc: value => (value && value.length == 9 || value.length == 11 || value.length == 13) || `Ingrese una Cedula o RNC válido`,
    RulesCelRncValidar: value => (value.length == 0 || value.length == 9 || value.length == 11 || value.length == 13) || `Ingrese una Cedula o RNC válido`,
    RTel: value => value != 10 || `telefono debe tener 10 digitos`,
    porciento: value => value <= 100 || `Porciento debe ser  menor o igual a 100`,
    porciento2: value => value <= 100 && value > 0 || `Porciento debe ser  menor o igual a 100`,
    Numericc: value => (value >= 0) || "Requerido",
    NumNocero: value => (value > 0) || "Requerido",
    email2: value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return pattern.test(value) || 'Invalid e-mail.'
    },
    email: value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return pattern.test(value) || value.length == 0 || "Requerido"
    },

    validando: value => {
        console.log('--validando--')
        console.log(value)
       return  value==true || "Campo invalido "
    }


}


//tipo de inventario producto
Vue.prototype.$RTipoInventario = [
    { codigo: 1, value: 'T', descripcion: 'Productos Terminados' },
    { codigo: 2, value: 'M', descripcion: 'Materia Prima' },
    { codigo: 3, value: 'G', descripcion: 'Material Gastable' },
],

Vue.prototype.$arrayPropiedasesGlobal= {
      'items-per-page-options': [10, 15, 20, 50],
      'items-per-page-text': 'Cantidad de Registros Por Paginas',
      showFirstLastPage: false
    },


Vue.prototype.$RDiagnosticos= [
  {
    categoria: '1. Enfermedades respiratorias',
    codigoCIE10: 'J00',
    Diagnostico: 'Rinofaringitis aguda —resfriado común—'
  },
  {
    categoria: '1. Enfermedades respiratorias',
    codigoCIE10: 'J01.9',
    Diagnostico: 'Sinusitis aguda, no especificada'
  },
  {
    categoria: '1. Enfermedades respiratorias',
    codigoCIE10: 'J02.9',
    Diagnostico: 'Faringitis aguda, no especificada'
  },
  {
    categoria: '1. Enfermedades respiratorias',
    codigoCIE10: 'J03.9',
    Diagnostico: 'Amigdalitis aguda, no especificada'
  },
  {
    categoria: '1. Enfermedades respiratorias',
    codigoCIE10: 'J06.9',
    Diagnostico: 'Infección aguda de las vías respiratorias superiores, no especificada'
  },
  {
    categoria: '1. Enfermedades respiratorias',
    codigoCIE10: 'J18.9',
    Diagnostico: 'Neumonía, no especificada'
  },
  {
    categoria: '1. Enfermedades respiratorias',
    codigoCIE10: 'J20.9',
    Diagnostico: 'Bronquitis aguda, no especificada'
  },
  {
    categoria: '1. Enfermedades respiratorias',
    codigoCIE10: 'J30.4',
    Diagnostico: 'Rinitis alérgica, no especificada'
  },
  {
    categoria: '1. Enfermedades respiratorias',
    codigoCIE10: 'J44.9',
    Diagnostico: 'Enfermedad pulmonar obstructiva crónica, no especificada'
  },
  {
    categoria: '1. Enfermedades respiratorias',
    codigoCIE10: 'J45.9',
    Diagnostico: 'Asma, no especificada'
  },

  {
    categoria: '2. Enfermedades endocrinas, nutricionales y metabólicas',
    codigoCIE10: 'E03.9',
    Diagnostico: 'Hipotiroidismo, no especificado'
  },
  {
    categoria: '2. Enfermedades endocrinas, nutricionales y metabólicas',
    codigoCIE10: 'E05.9',
    Diagnostico: 'Tirotoxicosis, no especificada'
  },
  {
    categoria: '2. Enfermedades endocrinas, nutricionales y metabólicas',
    codigoCIE10: 'E10.9',
    Diagnostico: 'Diabetes mellitus tipo 1, sin complicaciones'
  },
  {
    categoria: '2. Enfermedades endocrinas, nutricionales y metabólicas',
    codigoCIE10: 'E11.9',
    Diagnostico: 'Diabetes mellitus tipo 2, sin complicaciones'
  },
  {
    categoria: '2. Enfermedades endocrinas, nutricionales y metabólicas',
    codigoCIE10: 'E16.2',
    Diagnostico: 'Hipoglicemia, no especificada'
  },
  {
    categoria: '2. Enfermedades endocrinas, nutricionales y metabólicas',
    codigoCIE10: 'E66.9',
    Diagnostico: 'Obesidad, no especificada'
  },
  {
    categoria: '2. Enfermedades endocrinas, nutricionales y metabólicas',
    codigoCIE10: 'E78.0',
    Diagnostico: 'Hipercolesterolemia pura'
  },
  {
    categoria: '2. Enfermedades endocrinas, nutricionales y metabólicas',
    codigoCIE10: 'E78.5',
    Diagnostico: 'Hiperlipidemia, no especificada'
  },

  {
    categoria: '3. Enfermedades cardiovasculares',
    codigoCIE10: 'I10',
    Diagnostico: 'Hipertensión esencial —primaria—'
  },
  {
    categoria: '3. Enfermedades cardiovasculares',
    codigoCIE10: 'I20.9',
    Diagnostico: 'Angina de pecho, no especificada'
  },
  {
    categoria: '3. Enfermedades cardiovasculares',
    codigoCIE10: 'I25.9',
    Diagnostico: 'Enfermedad isquémica crónica del corazón, no especificada'
  },
  {
    categoria: '3. Enfermedades cardiovasculares',
    codigoCIE10: 'I50.9',
    Diagnostico: 'Insuficiencia cardíaca, no especificada'
  },
  {
    categoria: '3. Enfermedades cardiovasculares',
    codigoCIE10: 'I83.9',
    Diagnostico: 'Venas varicosas de los miembros inferiores sin úlcera ni inflamación'
  },

  {
    categoria: '4. Enfermedades digestivas',
    codigoCIE10: 'K21.9',
    Diagnostico: 'Enfermedad del reflujo gastroesofágico sin esofagitis'
  },
  {
    categoria: '4. Enfermedades digestivas',
    codigoCIE10: 'K29.7',
    Diagnostico: 'Gastritis, no especificada'
  },
  {
    categoria: '4. Enfermedades digestivas',
    codigoCIE10: 'K30',
    Diagnostico: 'Dispepsia'
  },
  {
    categoria: '4. Enfermedades digestivas',
    codigoCIE10: 'K58.9',
    Diagnostico: 'Síndrome del colon irritable sin diarrea'
  },
  {
    categoria: '4. Enfermedades digestivas',
    codigoCIE10: 'K59.0',
    Diagnostico: 'Constipación —estreñimiento—'
  },
  {
    categoria: '4. Enfermedades digestivas',
    codigoCIE10: 'K76.0',
    Diagnostico: 'Degeneración grasa del hígado, no clasificada en otra parte'
  },
  {
    categoria: '4. Enfermedades digestivas',
    codigoCIE10: 'K80.2',
    Diagnostico: 'Cálculo de la vesícula biliar sin colecistitis'
  },

  {
    categoria: '5. Enfermedades de la piel',
    codigoCIE10: 'L20.9',
    Diagnostico: 'Dermatitis atópica, no especificada'
  },
  {
    categoria: '5. Enfermedades de la piel',
    codigoCIE10: 'L21.9',
    Diagnostico: 'Dermatitis seborreica, no especificada'
  },
  {
    categoria: '5. Enfermedades de la piel',
    codigoCIE10: 'L23.9',
    Diagnostico: 'Dermatitis alérgica de contacto, de causa no especificada'
  },
  {
    categoria: '5. Enfermedades de la piel',
    codigoCIE10: 'L50.9',
    Diagnostico: 'Urticaria, no especificada'
  },
  {
    categoria: '5. Enfermedades de la piel',
    codigoCIE10: 'L60.0',
    Diagnostico: 'Uña encarnada'
  },
  {
    categoria: '5. Enfermedades de la piel',
    codigoCIE10: 'L63.9',
    Diagnostico: 'Alopecia areata, no especificada'
  },
  {
    categoria: '5. Enfermedades de la piel',
    codigoCIE10: 'L70.0',
    Diagnostico: 'Acné vulgar'
  },
  {
    categoria: '5. Enfermedades de la piel',
    codigoCIE10: 'L71.9',
    Diagnostico: 'Rosácea, no especificada'
  },
  {
    categoria: '5. Enfermedades de la piel',
    codigoCIE10: 'L80',
    Diagnostico: 'Vitíligo'
  },
  {
    categoria: '5. Enfermedades de la piel',
    codigoCIE10: 'L81.1',
    Diagnostico: 'Cloasma'
  },

  {
    categoria: '6. Enfermedades musculares y articulares',
    codigoCIE10: 'M17.9',
    Diagnostico: 'Gonartrosis, no especificada'
  },
  {
    categoria: '6. Enfermedades musculares y articulares',
    codigoCIE10: 'M25.5',
    Diagnostico: 'Dolor en articulación'
  },
  {
    categoria: '6. Enfermedades musculares y articulares',
    codigoCIE10: 'M54.2',
    Diagnostico: 'Cervicalgia'
  },
  {
    categoria: '6. Enfermedades musculares y articulares',
    codigoCIE10: 'M54.5',
    Diagnostico: 'Lumbago no especificado'
  },
  {
    categoria: '6. Enfermedades musculares y articulares',
    codigoCIE10: 'M65.9',
    Diagnostico: 'Sinovitis y tenosinovitis, no especificadas'
  },
  {
    categoria: '6. Enfermedades musculares y articulares',
    codigoCIE10: 'M79.1',
    Diagnostico: 'Mialgia'
  },

  {
    categoria: '7. Enfermedades urinarias y ginecológicas',
    codigoCIE10: 'N20.0',
    Diagnostico: 'Cálculo del riñón'
  },
  {
    categoria: '7. Enfermedades urinarias y ginecológicas',
    codigoCIE10: 'N30.0',
    Diagnostico: 'Cistitis aguda'
  },
  {
    categoria: '7. Enfermedades urinarias y ginecológicas',
    codigoCIE10: 'N39.0',
    Diagnostico: 'Infección de vías urinarias, sitio no especificado'
  },
  {
    categoria: '7. Enfermedades urinarias y ginecológicas',
    codigoCIE10: 'N40',
    Diagnostico: 'Hiperplasia de la próstata'
  },
  {
    categoria: '7. Enfermedades urinarias y ginecológicas',
    codigoCIE10: 'N76.0',
    Diagnostico: 'Vaginitis aguda'
  },
  {
    categoria: '7. Enfermedades urinarias y ginecológicas',
    codigoCIE10: 'N94.6',
    Diagnostico: 'Dismenorrea, no especificada'
  },

  {
    categoria: '8. Salud mental y enfermedades neurológicas',
    codigoCIE10: 'F32.9',
    Diagnostico: 'Episodio depresivo, no especificado'
  },
  {
    categoria: '8. Salud mental y enfermedades neurológicas',
    codigoCIE10: 'F41.1',
    Diagnostico: 'Trastorno de ansiedad generalizada'
  },
  {
    categoria: '8. Salud mental y enfermedades neurológicas',
    codigoCIE10: 'F41.9',
    Diagnostico: 'Trastorno de ansiedad, no especificado'
  },
  {
    categoria: '8. Salud mental y enfermedades neurológicas',
    codigoCIE10: 'G43.9',
    Diagnostico: 'Migraña, no especificada'
  },
  {
    categoria: '8. Salud mental y enfermedades neurológicas',
    codigoCIE10: 'G47.0',
    Diagnostico: 'Trastornos del inicio y del mantenimiento del sueño —insomnios—'
  },
  {
    categoria: '8. Salud mental y enfermedades neurológicas',
    codigoCIE10: 'G56.0',
    Diagnostico: 'Síndrome del túnel carpiano'
  },

  {
    categoria: '9. Síntomas y signos',
    codigoCIE10: 'R05',
    Diagnostico: 'Tos'
  },
  {
    categoria: '9. Síntomas y signos',
    codigoCIE10: 'R06.0',
    Diagnostico: 'Disnea'
  },
  {
    categoria: '9. Síntomas y signos',
    codigoCIE10: 'R10.4',
    Diagnostico: 'Otros dolores abdominales y los no especificados'
  },
  {
    categoria: '9. Síntomas y signos',
    codigoCIE10: 'R11',
    Diagnostico: 'Náusea y vómito'
  },
  {
    categoria: '9. Síntomas y signos',
    codigoCIE10: 'R42',
    Diagnostico: 'Mareo y desvanecimiento'
  },
  {
    categoria: '9. Síntomas y signos',
    codigoCIE10: 'R50.9',
    Diagnostico: 'Fiebre, no especificada'
  },
  {
    categoria: '9. Síntomas y signos',
    codigoCIE10: 'R51',
    Diagnostico: 'Cefalea'
  },
  {
    categoria: '9. Síntomas y signos',
    codigoCIE10: 'R53',
    Diagnostico: 'Malestar y fatiga'
  },

  {
    categoria: '10. Controles y otros motivos de consulta',
    codigoCIE10: 'Z00.0',
    Diagnostico: 'Examen médico general'
  },
  {
    categoria: '10. Controles y otros motivos de consulta',
    codigoCIE10: 'Z00.1',
    Diagnostico: 'Control de salud de rutina del niño'
  },
  {
    categoria: '10. Controles y otros motivos de consulta',
    codigoCIE10: 'Z01.4',
    Diagnostico: 'Examen ginecológico general de rutina'
  },
  {
    categoria: '10. Controles y otros motivos de consulta',
    codigoCIE10: 'Z71.3',
    Diagnostico: 'Consulta para instrucción y vigilancia de la dieta'
  }
],

    // Vue.directive('FormatoFecha', function (params0) {

    //   var params= new Date(params0).toISOString().substr(0,10);
    //   if (params != null) {
    //     if (params.length > 0) {
    //       return (
    //         params.substring(8, 10) +
    //         "-" +
    //         params.substring(5, 7) +
    //         "-" +
    //         params.substring(0, 4)
    //       );
    //     }
    //   }

    //   console.log(params0) // Object {color: 'white', text: 'hello!'}
    // })


    new Vue({
        router,
        store,
        vuetify,
        render: h => h(App)
    }).$mount("#app");
